import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $ProductComparisonSkuListModuleName } from "./productComparisonSkuList.types";

const getProductComparisonSkuList = (state: IState) =>
    getValueState(state, $ProductComparisonSkuListModuleName);

export { getProductComparisonSkuList };
